import { render } from "./AssignMentors.vue?vue&type=template&id=57a5f445&scoped=true"
import script from "./AssignMentors.vue?vue&type=script&lang=js"
export * from "./AssignMentors.vue?vue&type=script&lang=js"

import "./AssignMentors.vue?vue&type=style&index=0&id=57a5f445&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a5f445"]])

export default __exports__